module.exports = __webpack_public_path__ + "static/media/simplonbp-regular-webfont.aef9815f.woff";